export const languageValues = {
  tables: {
    presenca: {
      switch: 'Presença',
      conta: 'Conta',
      agencia: 'Agência',
      nome: 'Nome do Associado',
      labelCheckbox: 'Confirmar'
    }
  },

  inputs: {
    cpf: {
      label: 'CPF',
      placeholder: 'Digite o CPF...',
      invalidCPF: 'CPF Inválido!',
      requiredCPF: 'CPF é obrigatório!'
    },
    nome: {
      label: 'Nome',
      placeholder: 'Digite o nome...',
      requiredNome: 'Nome é obrigatório!'
    },
    dataNascimento: {
      label: 'Data de nascimento',
      placeholder: 'Digite a data de nascimento...',
      invalidDate: 'Data de nascimento inválida!',
      birthDateIsBefore: 'Data de nascimento deve ser anterior a hoje!'
    },
    telefone: {
      label: 'Telefone',
      placeholder: 'Digite o telefone...',
      requiredTelefone: 'Telefone é obrigatório!',
      invalidTelefone: 'Telefone inválido!'
    },
    sexo: {
      label: 'Sexo',
      placeholder: 'Selecione o sexo...'
    },
    email: {
      label: 'Email',
      placeholder: 'Digite o email...',
      invalidEmail: 'Email inválido!'
    }
  },

  dropdowns: {
    gender: {
      M: 'Masculino',
      F: 'Feminino'
    }
  },

  components: {
    select: {
      selectAll: 'Selecionar tudo',
      clearAll: 'Limpar tudo',
      panelFilterPlaceholder: 'Pesquisar',
      noOptionMessage: 'Nenhuma opção encontrada!',
      multiple: {
        numberOfItems: {
          items: (itens) =>
            `${itens} ite${itens !== 1 ? 'ns' : 'm'} selecionado${
              itens !== 1 ? 's' : ''
            }`
        }
      },
      single: {
        fakeOption: 'Selecione...'
      }
    },
    fileLoader: {
      carregando: 'Carregando'
    },
    modals: {
      alertModal: {
        confirm: 'Confirmar'
      },
      confirmModal: {
        cancel: 'Cancelar',
        confirm: 'Confirmar'
      },
      destructiveModal: {
        cancel: 'Cancelar',
        confirm: 'Confirmar'
      }
    }
  },

  months: {
    jan: {
      short: 'Jan',
      long: 'Janeiro'
    },
    fev: {
      short: 'Fev',
      long: 'Fevereiro'
    },
    mar: {
      short: 'Mar',
      long: 'Março'
    },
    abr: {
      short: 'Abr',
      long: 'Abril'
    },
    mai: {
      short: 'Mai',
      long: 'Maio'
    },
    jun: {
      short: 'Jun',
      long: 'Junho'
    },
    jul: {
      short: 'Jul',
      long: 'Julho'
    },
    ago: {
      short: 'Ago',
      long: 'Agosto'
    },
    set: {
      short: 'Set',
      long: 'Setembro'
    },
    out: {
      short: 'Out',
      long: 'Outubro'
    },
    nov: {
      short: 'Nov',
      long: 'Novembro'
    },
    dez: {
      short: 'Dez',
      long: 'Dezembro'
    }
  }
}
